export default () => jQuery(($) => {
	$('html').css('scroll-behavior', 'smooth');
	const wrapper = $('.faculty-staff--block');

	wrapper.addClass('dynamic');
	const firstWrapper = (wrapper.hasClass('collapsed')) ? 'collapsed' : 'open';

	if (wrapper.hasClass('collapsed') || wrapper.hasClass('open')) {
		wrapper.addClass(firstWrapper);
	} else {
		wrapper.addClass('collapsed');
	}

	const facStaff = wrapper.find('.faculty-staff--section-wrapper .faculty-staff--item');
	const names = facStaff.children('.faculty-staff--name');

	const nameSize = function () {
		if (wrapper.hasClass('collapsed')) {
			let largest = 0;
			names.css('height', 'auto').each(function (e) {
				const height = $(this).height();
				if (height > largest) {
					largest = height;
				}
				// if ($(this).siblings('.faculty-staff--image, .faculty-staff--image-replacement').length < 1) {
				// 	$(this).before('<div class="faculty-staff--image-replacement"></div>');
				// }
			});
			names.css('height', largest + 'px');
		}
	};

	const doInfoWidth = function () {
		const blocks = facStaff.filter('.open');
		blocks.each(function () {
			var revealed = $(this).children('.faculty-staff--wrapper');
			revealed.css('width', wrapper.width());
			$(this).append('<div class="shim"></div>');
		});
	};

	const facStaffExpandEnable = function () {
		facStaff.children('.faculty-staff--image, .faculty-staff--image-replacement, .faculty-staff--name').click(function (e) {
			e.preventDefault();
			let state = 'closed';
			if ($(this).parent().hasClass('open')) {
				state = 'open';
			}
			facStaff.removeClass('open');
			$('.faculty-staff--item .shim').remove();
			if ('closed' === state) {
				const facStaffInfoWrapper = $(this).parent().children('.faculty-staff--wrapper');
				facStaffInfoWrapper.css('overflow', 'hidden').css('height', 0);
				$(this).parent().addClass('open');
				doInfoWidth();
				const itemHeight = facStaffInfoWrapper.children('.faculty-staff--name').outerHeight() + facStaffInfoWrapper.children('.faculty-staff--container').outerHeight();
				const completion = function () {
					facStaffInfoWrapper.css('overflow', 'visible').css('height', 'auto');
				};
				// Use the itemHeight as the duration to ensure all open at same speed: 1ms/px
				facStaffInfoWrapper.animate({height: itemHeight}, itemHeight, 'linear', completion);
				$(this).parent().children('.shim').animate({height: itemHeight}, itemHeight, 'linear', completion);
			}
		});
	};

	const expander = $('<a href="#" class="expander">List View</a>');
	const collapser = $('<a href="#" class="collapser">Grid View</a>');
	if (expander.length && collapser.length) {
		expander.click(function (e) {
			e.preventDefault();
			wrapper.removeClass('collapsed').addClass('open');
			names.css('height', 'auto');
			facStaff.find('.faculty-staff--wrapper').css('width', 'auto').css('margin-left', 0);
			// Remove click-to-expand in List View so profile and photo links work properly
			facStaff.find('.faculty-staff--image, .faculty-staff--image-replacement, .faculty-staff--name').off('click');
		});
		collapser.click(function (e) {
			e.preventDefault();
			facStaff.removeClass('open');
			wrapper.addClass('collapsed').removeClass('open');
			nameSize();
			doInfoWidth();
			// Re-enable click-to-expand
			facStaffExpandEnable();
		});
		if (wrapper.children('.faculty-staff--wrapper').length > 0) {
			wrapper.children('.faculty-staff--nav-links').first().append(expander).append(collapser);
		} else if (wrapper.children('.department-info').length > 0) {
			wrapper.children('.department-info').append(expander).append(collapser);
		} else {
			wrapper.prepend(expander).prepend(collapser);
		}
		wrapper.find('.expander, .collapser').wrapAll('<span class="expandCollapse"></span>');
	}

	$(window).resize(doInfoWidth);
	facStaff.each(function () {
		$(this).children('.faculty-staff--name').clone().prependTo($(this).children('.faculty-staff--wrapper'));
	});

	$(window).resize(nameSize);
	$(window).load(function () {
		nameSize();

		if (wrapper.hasClass('collapsed')) {
			facStaffExpandEnable();
		}
	});
});
